// this file is automatically generated by git.revision.js script
export const versions = { revision: '70bac0241c' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = '70bac0241c';
